import {useEffect} from 'react';

import {useNavigate, useParams} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
    TabbedComponent,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useAccount} from '../hooks/useAccount';
import {useAccountsSelection} from '../hooks/useAccountsSelection';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {IndexPage as UsersPage} from "../../users/pages/IndexPage.tsx";
import {IndexPage as AccountApplicationsPage} from "../../account-applications/pages/IndexPage.tsx";
import {BillingTab} from "../profile/BillingTab.tsx";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";

export const EditPage = () => {

    const navigate = useNavigate();
    const {allowedActions} = useVerifiedPermissions()

    const {id: accountId} = useParams();

    if (typeof accountId === 'undefined') {
        throw new Error('accountId is required parameter');
    }

    const {
        record: account,
        updateRecord,
    } = useAccount(accountId);

    const {handleClearSelection} = useAccountsSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only effect: deliberately runs once, adding deps would re-fire it
    }, []);

    if (!account) {
        return <PlatformLoader message='Loading account...Please wait'/>;
    }

    const tabs = []
    if (allowedActions.includes(rbacActions.ListAccountApplications)) {
        tabs.push({
                      title: 'Applications',
                      component: <AccountApplicationsPage/>
                  })
    }
    if (allowedActions.includes(rbacActions.ListUsers)) {
        tabs.push({
                      title: 'Users',
                      component: <UsersPage/>
                  })
    }
    // FNP-575: Billing tab — moved off the left-hand Profile into its own tab here
    // next to Applications / Users. Gated on GetAccount (billing linkage is account
    // detail); the admin-only re-assign action inside is further gated by RBAC.
    if (allowedActions.includes(rbacActions.GetAccount)) {
        tabs.push({
                      title: 'Billing',
                      component: <BillingTab record={account}/>
                  })
    }

    return (
        <FormPageLayout
            title={account.email ? account.email : account.id}
            pageNavigation={<EditPageNavigation component={account}/>}
            tools={tools}
        >


            {mode === 'view' ?

                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 4
                    }}>
                        <Profile record={account}/>
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 8
                    }}>
                        <SimplePageContentWrapper>
                            <TabbedComponent tabs={tabs}></TabbedComponent>
                        </SimplePageContentWrapper>
                    </Grid.Col>
                </Grid>

                :
                <RecordForm
                    record={account}
                    handleSubmit={updateRecord}
                    handleCancel={() => navigate('/accounts')}
                />}


        </FormPageLayout>
    );
};
